import React from 'react'
import HelpPageForm, { FormMode } from '../components/HelpPageForm'
import { useTranslation } from 'react-i18next'

const AddHelpPage: React.FC = () => {
  const { t } = useTranslation()

  return (
    <>
      <HelpPageForm title={t('HelpPage:form.label.addHelpPage')} mode={FormMode.add} />
    </>
  )
}

export default AddHelpPage
